<template>
  
  <div id="approve-dialog" class="ui small modal approve-modal">

    <div class="ui header">
      Aprovação de Orçamento
    </div>

    <div class="content">       

      <div class="ui orange message">
        <strong><i class="exclamation circle icon"></i>Atenção</strong>
        <p v-if="!isRulesOK">Uma ou mais regras de negócio foram violadas.</p>
        <p v-if="!isItemsOk">Um ou mais itens com preço abaixo do mínimo não foram aprovados.</p>
        <p class="m-t-20">Confirma aprovação do orçamento ?</p>
      </div> 

    </div>

    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>
      <button type="button" class="ui blue button" @click="onApprove()">
        <i class="check icon"></i>
        Aprovar
      </button>
    </div>

  </div>

</template>

<script>

  import QuotationService from "@/services/quotation-service"

  export default {
    
    props: ["quotation"],  

    computed: {

      isRulesOK() {

        if (!this.quotation)
          return false

        let isOk = true        

        this.quotation.rules.forEach((rule) => {
          if (rule.type !== "2" && !rule.isOk)
            isOk = false
        })

        return isOk
      },

      isItemsOk() {

        if (!this.quotation)
          return false

        let isOk = true        

        this.quotation.items.forEach((item) => {
          if (QuotationService.hasPriceAlert(item) && item.appPrice == 0)
            isOk = false
        })

        return isOk
      },
    },

    beforeDestroy() {
      $(".approve-modal").remove()
    },

    methods: {

      show() {
        
        if (this.isRulesOK && this.isItemsOk) {
          this.onApprove()
        } else {
          $("#approve-dialog").modal("show")
        }        
      },

      hide() {
        $("#approve-dialog").modal("hide")
      },

      onApprove() {
        
        this.$emit("onApprove")

        this.hide()
      }
    },
  }

</script>

